export const ECONOMY_SEAT_SIZE = 44;
export const BUSINESS_SEAT_WIDTH = ECONOMY_SEAT_SIZE * 2;
export const SEAT_HEIGHT = 52;
